import { render, staticRenderFns } from "./v-account-selector.vue?vue&type=template&id=248a0fb0&scoped=true"
import script from "./v-account-selector.vue?vue&type=script&lang=js"
export * from "./v-account-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248a0fb0",
  null
  
)

export default component.exports